import { colors } from 'ui/theme/colors';
import { SvgIcon, SvgIconProps } from '../SvgIcon';
import { getColor } from '../utils';

export const MoveToFolder = ({
  height = 24,
  width = 24,
  color = colors.grey90,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon width={width} height={height} viewBox="0 0 20 20" {...props}>
    <path
      d="M7.1877 15.0625H2.83545"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.1875 7.1875V4.9375C16.1875 4.63913 16.069 4.35298 15.858 4.142C15.647 3.93103 15.3609 3.8125 15.0625 3.8125H7.1875V2.6875C7.1875 2.38913 7.06897 2.10298 6.858 1.892C6.64702 1.68103 6.36087 1.5625 6.0625 1.5625H2.6875C2.38913 1.5625 2.10298 1.68103 1.892 1.892C1.68103 2.10298 1.5625 2.38913 1.5625 2.6875V13.7875C1.56673 14.0938 1.68113 14.3884 1.88476 14.6173C2.08839 14.8462 2.36764 14.9942 2.6714 15.034C2.97516 15.0739 3.28313 15.0031 3.53895 14.8345C3.79477 14.6659 3.98133 14.4109 4.0645 14.116L5.82775 8.0005C5.89544 7.76601 6.03754 7.5599 6.23262 7.41325C6.42771 7.2666 6.66519 7.18736 6.90925 7.1875H17.3125C17.4849 7.18744 17.6551 7.22703 17.8098 7.3032C17.9645 7.37937 18.0997 7.49009 18.2048 7.6268C18.3099 7.76352 18.3821 7.92256 18.416 8.09166C18.4499 8.26075 18.4444 8.43536 18.4 8.602"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.4375 13.9375C9.4375 15.131 9.91161 16.2756 10.7555 17.1195C11.5994 17.9634 12.744 18.4375 13.9375 18.4375C15.131 18.4375 16.2756 17.9634 17.1195 17.1195C17.9634 16.2756 18.4375 15.131 18.4375 13.9375C18.4375 12.744 17.9634 11.5994 17.1195 10.7555C16.2756 9.91161 15.131 9.4375 13.9375 9.4375C12.744 9.4375 11.5994 9.91161 10.7555 10.7555C9.91161 11.5994 9.4375 12.744 9.4375 13.9375Z"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.6875 13.9375L16.1875 13.9375"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.1875 13.9375L14.5 12.25"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.1875 13.9375L14.5 15.625"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);
